/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'./internal/FontPropTypes',
	'./internal/TextFormatView'
], function (React, PropTypes, FontPropTypes, TextFormatView) {

	const {
		TextPropType,
		FontOptionsPropType,
		ColorOptionsPropType,
		DefaultStatePropType
	} = FontPropTypes;

	class TextFormatComponent extends React.Component {
		static propTypes = {
			state: TextPropType,
			onStateChange: PropTypes.func.isRequired,
			onClose: PropTypes.func.isRequired,
			supportsStyleAndAlignment: PropTypes.bool,
			supportsTextWrap: PropTypes.bool,
			supportsLabelShadow: PropTypes.bool,
			supportsApplyToAll: PropTypes.bool,
			supportsFontStyle: PropTypes.bool,
			supportsContrastLabelColor: PropTypes.bool,
			supportsTitle:PropTypes.bool,
			colorOptions: ColorOptionsPropType.isRequired,
			fontOptions: FontOptionsPropType.isRequired,
			fontSizeOptions: FontOptionsPropType.isRequired,
			groupedProperties: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
			defaultState: DefaultStatePropType.isRequired,
			disableFontSizeAndColor: PropTypes.bool
		};

		constructor(props) {
			super(props);
			this.state = { ...props.state };
		}

		render() {
			return (
				<TextFormatView
					state={this.state}
					onStateChange={newState => this.onStateChange(newState)}
					onClose={this.props.onClose}
					supportsStyleAndAlignment={this.props.supportsStyleAndAlignment}
					supportsTextWrap={this.props.supportsTextWrap}
					supportsLabelShadow={this.props.supportsLabelShadow}
					supportsApplyToAll={this.props.supportsApplyToAll}
					supportsFontStyle={this.props.supportsFontStyle}
					supportsContrastLabelColor={this.props.supportsContrastLabelColor}
					supportsTitle={this.props.supportsTitle}
					colorOptions={this.props.colorOptions}
					fontOptions={this.props.fontOptions}
					fontSizeOptions={this.props.fontSizeOptions}
					groupedProperties={this.props.groupedProperties}
					defaultState={this.props.defaultState}
					disableFontSizeAndColor= {this.props.disableFontSizeAndColor}
				/>
			);
		}

		onStateChange(newState) {
			this.setState(newState);
			this.props.onStateChange(newState);
		}
	}

	return TextFormatComponent;
});
